import { render } from "./AuthFormReset.vue?vue&type=template&id=27437a7e"
import script from "./AuthFormReset.vue?vue&type=script&lang=ts"
export * from "./AuthFormReset.vue?vue&type=script&lang=ts"
script.render = render

export default script